<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="pvi"></a> Copyright © 2011 by Ward Just</p>
<p class="timebreak"> <br/></p>
<p class="center"><span style="font-size: smaller">ALL RIGHTS RESERVED</span></p>
<p class="timebreak"> <br/></p>
<p class="center">For information about permission to reproduce selections from this book, write to Permissions, Houghton Mifflin Harcourt Publishing Company, 215 Park Avenue South, New York, New York 10003.</p>
<p class="timebreak"> <br/></p>
<p class="center"><a href="http://www.hmhco.com/popular-reading" target="_blank">www.hmhco.com</a></p>
<p class="timebreak"> <br/></p>
<p class="center">The Library of Congress has cataloged the print edition as follows:<br/>
Just, Ward S.<br/>
Rodin’s debutante / Ward Just.<br/>
p. cm.<br/>
<span style="font-size: smaller">ISBN</span> 978-0-547-50419-3<br/>
1. Coming of age—Fiction. 2. Boarding schools—Fiction. 3. Friendship—Fiction. 4. Maturation (Psychology)—Fiction. I. Title.<br/>
<span style="font-size: smaller">PS</span>3560.<span style="font-size: smaller">U</span>75<span style="font-size: smaller">R</span>63 2011<br/>
813'.54—dc22 2010042695</p>
<p class="timebreak"> <br/></p>
<p class="center">eISBN 978-0-547-50420-9<br/>
v4.1214</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?657c9927